if (typeof wp !== "undefined") {
    const { createHigherOrderComponent } = wp.compose;
    const { InspectorControls, PanelColorSettings } = wp.blockEditor;
    const { PanelBody } = wp.components;

    wp.hooks.addFilter(
        "blocks.registerBlockType",
        "peagsus/group-block-hover-color-attr",
        (settings) => {
            if (settings.name !== "core/group") {
                return settings;
            }

            settings.attributes = {
                ...settings.attributes,
                hoverBackgroundColor: {
                    type: "string",
                },
                hoverTextColor: {
                    type: "string",
                },
            };

            return settings;
        }
    );

    const withInspectorControls = createHigherOrderComponent((BlockEdit) => {
        return (props) => {
            const { name } = props;

            if (name === "core/group") {
                return (
                    <PegasusExtendedGroupBlock
                        BlockEdit={BlockEdit}
                        {...props}
                    />
                );
            }

            return <BlockEdit {...props} />;
        };
    }, "withInspectorControl");

    const PegasusExtendedGroupBlock = (props) => {
        const { BlockEdit, setAttributes, attributes } = props;
        const { hoverBackgroundColor } = attributes;
        const { hoverTextColor } = attributes;

        return (
            <>
                <BlockEdit {...props} />
                <InspectorControls>
                    <PanelColorSettings
                        title="Hover Background Color"
                        colorSettings={[
                            {
                                value: hoverBackgroundColor,
                                onChange: (colorValue) =>
                                    setAttributes({
                                        hoverBackgroundColor: colorValue,
                                    }),
                                label: "Hover Background Color",
                            },
                        ]}
                    />
                    <PanelColorSettings
                        title="Hover Content Color"
                        colorSettings={[
                            {
                                value: hoverTextColor,
                                onChange: (colorValue) =>
                                    setAttributes({
                                        hoverTextColor: colorValue,
                                    }),
                                label: "Hover Content Color",
                            },
                        ]}
                    />
                </InspectorControls>
            </>
        );
    };

    wp.hooks.addFilter(
        "editor.BlockEdit",
        "peagsus/group-block-hover-color",
        withInspectorControls
    );

    wp.hooks.addFilter(
        "blocks.getSaveContent.extraProps",
        "pegasus/save-group-block-hover-color-attr",
        (props, blockType, attributes) => {
            const { hoverBackgroundColor = null } = attributes;
            const { hoverTextColor = null } = attributes;

            if (blockType.name !== "core/group") {
                return props;
            }

            props.hoverBackgroundColor = hoverBackgroundColor;
            props.hoverTextColor = hoverTextColor;


            return props;
        }
    );
}
